export default {
  sales: {
    Region: 'Region',
    Customer: 'Customer',
    RegionName: 'Region Name',
    CustomerName: 'Customer Name',
    ProvinceName: 'Province Name',
    CityName: 'City Name',
    Year: 'Year',
    YearMonth: 'Year Month',
    TotalAmount: 'Total Amount',
    UnpaidAmount: 'Unpaid Amount',
    PaidAmount: 'Paid Amount',
    ReturnAmount: 'Return Amount',
    WriteOffAmount: 'Write Off Amount',
    UnWriteOffAmount: 'Un Write Off Amount',
    ValidAmount: 'Valid Amount',
    ChooseRegion: 'Choose Region',
    Dealer: 'Dealer',
    PleaseChooseUnapprovedOrder: 'Please Choose Unapproved Order'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/ims/sales.js